import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const CardSkeleton = () => (
  <div>
    <Card>
      <Card.Header className="p-0">
        <div className="ratio ratio-3x2">
          <Skeleton height="100%" style={{ lineHeight: 2 }} />
        </div>
      </Card.Header>
      <Card.Body>
        <Skeleton height="2.5rem" width="60%" className="mb-3" />
        <Skeleton height="1rem" count={3} />
      </Card.Body>
      <Card.Footer className="bg-white border-top-0">
        <Skeleton height="2rem" width="40%" />
      </Card.Footer>
    </Card>
  </div>
);

export default CardSkeleton;
